module.exports = __webpack_public_path__ + "static/FAMR-34843adf9695e02ddd2b1e3ca4f7f7c4.jpg";